(function() {
  var MIN_QTY = 8;

  function enforceMinOnCart() {
    var checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout-button, button[type="submit"].cart__cta');
    checkoutBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var total = cart.items.reduce(function(sum, item) { return sum + item.quantity; }, 0);
            if (total < MIN_QTY) {
              e.preventDefault();
              e.stopPropagation();
              showMinQtyAlert(total);
            }
          });
      });
    });
  }

  function enforceMinOnProduct() {
    var qtyInputs = document.querySelectorAll('input[name="quantity"]');
    qtyInputs.forEach(function(input) {
      input.setAttribute('min', MIN_QTY);
      if (parseInt(input.value) < MIN_QTY) { input.value = MIN_QTY; }
      input.addEventListener('change', function() {
        if (parseInt(this.value) < MIN_QTY) {
          this.value = MIN_QTY;
          showMinQtyNotice();
        }
      });
    });
  }

  function showMinQtyAlert(current) {
    var existing = document.getElementById('hb-min-qty-alert');
    if (existing) existing.remove();
    var alert = document.createElement('div');
    alert.id = 'hb-min-qty-alert';
    alert.innerHTML = '<div style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#543128;color:#eceada;padding:36px 40px;border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,0.4);z-index:99999;text-align:center;max-width:380px;width:90%;font-family:DM Sans,sans-serif;"><div style="font-size:32px;margin-bottom:12px;">📦</div><h3 style="font-family:Lora,serif;font-size:20px;color:#c9a22d;margin:0 0 10px;">Minimum 8 Bars Required</h3><p style="font-size:14px;color:rgba(236,234,218,0.8);line-height:1.6;margin:0 0 20px;">You have ' + current + ' bar' + (current !== 1 ? 's' : '') + ' in your cart. Our bars are made in batches of 8 — please add ' + (MIN_QTY - current) + ' more to checkout.</p><button onclick="document.getElementById(\'hb-min-qty-alert\').remove()" style="background:#c9a22d;color:#3a1e14;border:none;padding:12px 28px;border-radius:30px;font-family:DM Sans,sans-serif;font-size:13px;font-weight:700;cursor:pointer;">GOT IT — ADD MORE</button></div><div onclick="document.getElementById(\'hb-min-qty-alert\').remove()" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:99998;"></div>';
    document.body.appendChild(alert);
  }

  function showMinQtyNotice() {
    var notice = document.getElementById('hb-min-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.id = 'hb-min-notice';
      notice.style.cssText = 'color:#c9a22d;font-family:DM Sans,sans-serif;font-size:13px;font-weight:600;margin-top:8px;';
      notice.textContent = 'Minimum quantity is 8 bars per batch.';
      var input = document.querySelector('input[name="quantity"]');
      if (input) input.parentNode.insertAdjacentElement('afterend', notice);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    enforceMinOnCart();
    enforceMinOnProduct();
  });
})();